export default __webpack_public_path__ + "static/media/pos-pro-12.2ed9f345.jpg";